import { useSyncExternalStore } from 'react';

/* ══════════════════════════════════════════════════════
   useIsMobile — Single source of truth for the mobile
   breakpoint. Subscribes to matchMedia and fires only on
   boundary crossings (not on every pixel of resize).
   SSR-safe via useSyncExternalStore.
   Keep MOBILE_BREAKPOINT_PX in sync with .hide-mobile /
   .hide-desktop in src/styles/global.css.
   ══════════════════════════════════════════════════════ */

export const MOBILE_BREAKPOINT_PX = 767;

const QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX}px)`;

function subscribe(callback) {
  if (typeof window === 'undefined') return () => {};
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

function getSnapshot() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(QUERY).matches;
}

function getServerSnapshot() {
  return false;
}

export default function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
